import Vue from 'vue'
import { mapState } from 'vuex'
import FreelancerDetails from '@/models-ts/user/details/FreelancerDetails'
import { RootState } from '@/store'

export default Vue.extend({
  props: {
    freelancer: FreelancerDetails,
  },
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.vacancyChat.application.value,
    }),
    position() {
      return this.application?.freelancer?.position || this.freelancer?.position
    },
    cvFileSrc() {
      return this.application?.cvFile?.src || this.freelancer?.cv?.[0]?.src
    },
  },
})
